import { HubAction } from './hub.action';

export class OrderLeavingEditModeAction extends HubAction {
    constructor(user: string, orderNumber: number) {
        super('LeavingEditMode', user, orderNumber);
    }

    public action(): void {}
}
